import * as sc from "../styled/scInfo";
import * as ico from "../styled/icon";
import Reveal from "./Reveal";

import { infoData } from "../contants";

const Info = () => (
  <sc.infoCont id="olanaklar">
    <Reveal>
      <sc.infoText>Olanaklar</sc.infoText>
    </Reveal>
    <sc.infoContainer>
      {infoData.map((data, i) => (
        <Reveal key={data.title} delay={i * 80}>
          <Card {...data} />
        </Reveal>
      ))}
    </sc.infoContainer>
  </sc.infoCont>
);

const Card = ({ icon, title, content }) => (
  <sc.infoItem>
    <sc.infoCard>
      <ico.MyComponent iconName={icon} />
      <sc.infoTitle>{title}</sc.infoTitle>
      <sc.infoContent>{content}</sc.infoContent>
    </sc.infoCard>
  </sc.infoItem>
);

export default Info;
